'use client';

import { useTranslations } from 'next-intl';
import DocumentPageShell from '@/components/sections/shared/DocumentPageShell';
import PolicyPageContent from '@/components/sections/shared/PolicyPageContent';
import type { DisclaimerData } from '@/types/disclaimer';

interface DisclaimerProps {
  locale: string;
  data: DisclaimerData | null;
}

export default function Disclaimer({ locale, data }: DisclaimerProps) {
  const tCommon = useTranslations('common');
  const tErrors = useTranslations('errors');

  if (!data) {
    const title = tCommon('footer.bottomLinks.disclaimer');
    return (
      <DocumentPageShell title={title}>
        <div className="rounded-2xl border border-[#e4e4e4] bg-white p-8 text-center shadow-sm">
          <p className="text-base text-[#737373]">{tErrors('global.description')}</p>
        </div>
      </DocumentPageShell>
    );
  }

  return <PolicyPageContent locale={locale} data={data} />;
}
